import React, { Fragment } from 'react';

import { Transition } from '@headlessui/react';

export interface FadeTransitionProps {
  children: React.ReactNode;
  as?: React.ElementType;
}

const FadeTransition: React.FC<FadeTransitionProps> = ({ children, as = Fragment }) => {
  return (
    <Transition.Child
      as={as}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      {children}
    </Transition.Child>
  );
};

export default FadeTransition;
